import React from 'react';
import { ClockIcon, ExternalLinkIcon, FootprintsIcon, MapPinIcon, SendIcon } from 'lucide-react';
import type { MapCardData } from '../../types/lexce';
interface MapCardProps {
  card: MapCardData;
}
export function MapCard({
  card
}: MapCardProps) {
  return <section className="overflow-hidden rounded-2xl border border-vin-line bg-white shadow-card" data-id="element-105" data-mp="1q34acon0aqd4">
      <div className="relative" data-id="element-106" data-mp="1l8qaoa1b9x2n">
        <img src={card.mapImage} alt={`Walking route to ${card.room}`} className="h-40 w-full object-cover" data-id="element-107" data-mp="1zyxtwrz57k4e" />
        <div className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-white/95 px-2.5 py-1 text-[11px] font-semibold text-vin-primary" data-id="element-108" data-mp="1v15rv54sahmh">
          <FootprintsIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-109" data-mp="28xt2ubtkn8be" />
          {card.walkMinutes} min · {card.distance}
        </div>
        <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2 rounded-xl bg-vin-primary/95 px-3 py-2 text-white" data-id="element-110" data-mp="ell3mma7w59t">
          <MapPinIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-111" data-mp="am3thfjuijyb" />
          <div className="min-w-0" data-id="element-112" data-mp="340afgcxi68x1">
            <p className="truncate text-[13px] font-semibold leading-4" data-id="element-113" data-mp="341bzv80es7rf">{card.room}</p>
            <p className="truncate text-[11px] text-white/75" data-id="element-114" data-mp="38z559ytw0xqn">{card.building}</p>
          </div>
        </div>
      </div>

      <div className="p-4" data-id="element-115" data-mp="3dvluyxgqjk5u">
        <div className="flex items-baseline justify-between gap-3" data-id="element-116" data-mp="3io585tbigda4">
          <div className="min-w-0" data-id="element-117" data-mp="3iqhzuy72m20d">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-vin-tertiary" data-id="element-118" data-mp="3no1alo4k7wnk">{card.courseCode}</p>
            <h3 className="truncate text-[15px] font-semibold text-vin-ink" data-id="element-119" data-mp="3robpxre8rzf3">{card.courseName}</h3>
          </div>
          <span className="flex shrink-0 items-center gap-1 rounded-full bg-vin-secondary/10 px-2 py-0.5 text-[11px] font-semibold text-vin-secondary" data-id="element-120" data-mp="k3mb0cpru2i">
            <ClockIcon className="h-3 w-3" aria-hidden="true" data-id="element-121" data-mp="22a5c4tfsd7s5" />
            {card.startsIn}
          </span>
        </div>
        <p className="mt-1 text-[13px] text-vin-muted" data-id="element-122" data-mp="278qdiw6rxxi6">
          {card.time} · {card.instructor}
        </p>

        <div className="mt-4 space-y-2" data-id="element-123" data-mp="1z9lmq8x1aiik">
          <button type="button" className="flex w-full items-center justify-center gap-2 rounded-xl bg-vin-primary px-4 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-vin-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-vin-tertiary" data-id="element-124" data-mp="1zan0il5fpj3z">
            <ExternalLinkIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="2i63ntgxrvurh" />
            {card.primaryAction}
          </button>
          <button type="button" className="flex w-full items-center justify-center gap-2 rounded-xl border border-vin-line px-4 py-2.5 text-sm font-semibold text-vin-primary transition-colors duration-150 ease-out hover:bg-vin-mist focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-vin-tertiary" data-id="element-126" data-mp="2e5ku1hcbkemn">
            <SendIcon className="h-4 w-4" aria-hidden="true" data-id="element-127" data-mp="2wxlwsus7sp1c" />
            {card.secondaryAction}
          </button>
        </div>
      </div>
    </section>;
}